import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";
import { Link } from "react-router-dom";

const multiple = nota.global.multiple;

const StyledListLine = styled(NanoFlex)`
  width: 100%;
  .listLineWrapper {
    padding: ${multiple + "px"}; /* 8px */
    .titleLineWrapper {
      justify-content: flex-start;
      width: 120px;
      p {
        text-transform: uppercase;
      }
    }
    .infoLineWrapper {
      width: 100%;
      padding-left: ${multiple + "px"}; /* 8px */
      align-items: flex-start;
      justify-content: flex-start;
      .blueInfo {
        text-transform: uppercase;
        color: ${nota.color.main.default};
      }
    }
    .linkWrapper {
      text-decoration: none;
      width: 100%;
      .linkText {
        color: ${nota.color.main.default};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  /* &:nth-child(odd) {
    background: ${nota.color.neutral.NeuFour};
  } */
  @media only screen and (max-width: 800px) {
    .listLineWrapper {
      flex-direction: column;
      .titleLineWrapper {
        width: 100%;
      }
      .infoLineWrapper {
        padding-left: 0;
      }
    }
  }
`;

class ListLine extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledListLine>
        <NanoFlex className="listLineWrapper" alignItems={"flex-start"}>
          <NanoFlex className="titleLineWrapper">
            <Type.p>{this.props.titleLine}</Type.p>
          </NanoFlex>
          <NanoFlex className="infoLineWrapper" flexDirection={"column"}>
            {this.props.blueInfoLine && <Type.p className="blueInfo">{this.props.blueInfoLine}</Type.p>}
            {this.props.infoLine && !this.props.isHref && <Type.p>{this.props.infoLine}</Type.p>}
            {this.props.infoLine && this.props.isHref && (
              <a className="linkWrapper" target="_blank" href={this.props.infoLine}>
                <Type.p className="linkText">{this.translation.components.listLine.link}</Type.p>
              </a>
            )}
            {this.props.secInfoLine && (
              <Type.p>
                <b>{this.props.secInfoLine}</b>
              </Type.p>
            )}
          </NanoFlex>
        </NanoFlex>
      </StyledListLine>
    );
  }
}

// Set default props
ListLine.defaultProps = {
  titleLine: "", // 'Line Title'
  infoLine: "", // 'Line Info'
  secInfoLine: "", // 'Secondary Line Info'
  blueInfoLine: "", // 'Blue Line Info'
};

export default ListLine;

// --- // Documentation // --- //
/*
import ListLine from './../Nano/ListLine.js';

<ListLine
    titleLine={'Line Title'}
    infoLine={'Line Info'}
    secInfoLine={'Secondary Line Info'}
    blueInfoLine={'Blue Line Info'}
/>
*/
